import InvoiceIcon from '@material-ui/icons/LibraryBooks';

import InvoiceList from './InvoiceList';

export default {
    list: InvoiceList,
    icon: InvoiceIcon,
};
